s<template>
<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <span class="title_head">Shop & Establishment Search</span> 
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12">
              <div v-if="errorMessage.message != ''" class="alert alert-success" >
               <center> <strong></strong>{{errorMessage.message}}</center>
              </div>
            </div>
          </div>
          <b-row>
            <b-col sm="3">
              <b-form-group>
                <label for="name">Shop Name </label>
                <b-form-input type="text" autocomplete="off" v-model="search.name"  id="name1" placeholder="Enter Shop Name"></b-form-input>
              </b-form-group>
            </b-col>
             <b-col sm="3">
              <b-form-group>
                <label for="name">City </label>
                <model-list-select :list="citysrchopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="id" option-text="city_name" v-model="search.city" placeholder="Select Shop City" @searchchange="searchcity"></model-list-select>
              </b-form-group>
            </b-col>
             <b-col sm="3">
              <b-form-group>
                <label for="name">Pincode </label>
                <b-form-input type="text" v-model="search.pincode" :class="{'is-invalid':hasErrors.shopad2}" autocomplete="off" id="name3" placeholder="Enter Pincode"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <label for="name"></label>
              <button v-if="shop_view === true" type="button" class="btn btn-pill btn-primary serach_bttn" @click.prevent="serachprev" style="margin-top: 24px; margin-left: 16%">
            <i class="fa fa-search"></i> Search</button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
  
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <span class="title_head">Shop List</span>&nbsp;&nbsp;
          <span>
            <button v-if="shop_rights === true" type="button" class="btn btn-sm btn-primary label_bttn" variant="secondary" @click="addshopnew"><i class="fa fa-plus"></i> Add Shop</button>
          </span>
        </div> 
        <div class="card-body">
          <template>
            <div>
              <vue-good-table :columns="columns" :rows="rows" mode="remote" ref="my-table" @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :pagination-options="{enabled: true, perPage: 10}" styleClass="vgt-table striped bordered table-sm condensed">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'action'">
                    <i class="fa fa-eye" style="color: rgb(99, 194, 222);" @click.prevent="viewshop(props.row)"></i>
                    <span v-if="shop_rights === true">
                      <i class="fa fa-edit" @click.prevent="editpro(props.row)"></i>
                    </span>
                    <span v-else>
                      <i class="fa fa-edit" style="color:grey !important;"></i>
                    </span>
                    
                  </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>
              </vue-good-table>
      
              <b-modal title="Shop Establishment" no-close-on-esc no-close-on-backdrop class="modal-info" size="lg" hide-footer v-model="largeModal" @ok="largeModal = false">
                <b-row>
                  <b-col sm="4">
                    <div class="form-group">
                      <label for="name">Shop Type<span style="color:red">*</span></label>
                      <select class="form-control" v-model="shoptype" ref="shptype">
                        <option selected readonly value="">Select Your Shop Type</option>
                        <option value="shop">Shop</option>
                        <option value="warehouse">Warehouse</option>
                      </select> 
                      <small  class="help-block" v-if="hasErrors.cmptype" ><strong style="color: red;">Enter Company  Type</strong></small>
                    </div>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name"> Shop Name <span class="star" style="color:red">*</span></label>
                      <b-form-input type="text" ref="txtshopname" @blur.native="chkShopExist()" v-model="shop.name" :class="{'is-invalid':hasErrors.shopnm}" autocomplete="off"  placeholder="Enter Shop Name" ></b-form-input>
                      <!--
                      <b-form-input type="text" ref="txtshopname" v-model="shop.name" :class="{'is-invalid':hasErrors.shopnm}" autocomplete="off"  placeholder="Enter Shop Name"></b-form-input>-->
                      <small class="form-text text-muted" v-if="hasErrors.shopnm" ><strong style="color: red;">Enter Valid Shop Name</strong></small>
                      <small  class="form-text text-muted" v-if="hasErrors.shopnmexist === true" ><strong style="color: red;">Shop Name Already Exist</strong></small>
                    </b-form-group>
                  </b-col>
                   <b-col sm="4">
                    <b-form-group>
                      <label for="name">Address Line 1 <span class="star" style="color:red">*</span></label>
                      <b-form-input type="text" v-model="shop.address1" :class="{'is-invalid':hasErrors.shopad1}" autocomplete="off" placeholder="Enter Address Line 1"></b-form-input>
                    <small  class="form-text text-muted" v-if="hasErrors.shopad1" ><strong style="color: red;">Enter Valid Shop Address</strong></small>
                    </b-form-group>
                  </b-col>            
                </b-row>
                
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Address Line 2 </label>
                      <b-form-input type="text" v-model="shop.address2" :class="{'is-invalid':hasErrors.shopad2}" autocomplete="off"  placeholder="Enter Address Line 2"></b-form-input>
                      <small class="form-text text-muted" v-if="hasErrors.shopad2" ><strong style="color: red;">Enter Valid Shop Address</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Country <span class="star" style="color:red">*</span></label>
                      <model-list-select :list="conopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="country_name" option-text="country_name" v-model="con" placeholder="Select Country" @input="state1"></model-list-select>
                      <small  class="form-text text-muted" v-if="hasErrors.shopcntry" ><strong style="color: red;">Select Country</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">State <span class="star" style="color:red">*</span></label>
                      <model-list-select :list="stateopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="state_name" option-text="state_name" v-model="state" placeholder="Select State" @input="city1"></model-list-select>
                      <small class="form-text text-muted" v-if="hasErrors.shopstate" ><strong style="color: red;">Select State</strong></small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">City <span class="star" style="color:red">*</span></label>
                      <model-list-select :list="cityopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="city_name" option-text="city_name" v-model="city" placeholder="Select City"></model-list-select>
                      <small  class="form-text text-muted" v-if="hasErrors.shopcity" ><strong style="color: red;">Select City</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Pincode <span class="star" style="color:red">*</span></label>
                      <b-form-input type="text" v-model="shop.pincode" :class="{'is-invalid':hasErrors.shoppin}" autocomplete="off" placeholder="Enter your Pincode"></b-form-input>
                      <small class="form-text text-muted" v-if="hasErrors.shoppin" ><strong style="color: red;" >Enter Valid Pincode</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">GST No. </label>
                      <b-form-input type="text"  v-model="shop.gst" onkeyup="this.value = this.value.toUpperCase();" :class="{'is-invalid':hasErrors.shop_gst}" autocomplete="off" placeholder="Enter Your GST No"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.shop_gst" ><strong style="color: red;">Enter Valid GST No</strong></small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Contact No. <span class="star" style="color:red">*</span></label>
                      <b-form-input type="text" v-model="shop.phone" :class="{'is-invalid':hasErrors.shopph}" autocomplete="off"  placeholder="Enter Shop Phone Number"></b-form-input>
                      <small class="form-text text-muted" v-if="hasErrors.shopph" ><strong style="color: red;">Enter Valid Phone Number</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="5">
                    <b-form-group>
                      <label for="name">Select Shop Admin <span class="star" style="color:red">*</span></label>
                      <model-list-select :list="useropt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="email" :custom-text="nameAndnumber" v-model="adminuser" placeholder="Select Shop Admin"></model-list-select>
                      <small class="form-text text-muted" v-if="hasErrors.shopadmin"><strong style="color: red;">Select Shop Admin</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="name">Locate Address In Map </label></br>
                      <b-button type="button" variant="warning" @click="openwarning">Select Address In Map</b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                <b-col sm="12">
                    <b-form-group>
                      <label for="name"><!--<span class="star" style="color:red">*</span>--> </label>
                      Sale Price Editable : <input type="checkbox" autocomplete="off"  v-model="shop.sale_price_editable">
                      <!-- <b-form-input type="checkbox" v-model="shop.sale_price_editable"></b-form-input> -->
                    </b-form-group>
                  </b-col>
                </b-row>
                <div v-show="show_save_btn" class="card-footer modal_footer">
                  <b-row>
                    <b-col sm="12">
                    <button type="submit" class="btn btn-sm btn-primary" @click.prevent="Successsub()"><i class="fa fa-dot-circle-o"> </i> &nbsp;Save</button>
                    </b-col>
                  </b-row>
                </div>
              </b-modal>
               <b-modal
            title="Plan Limit Reached"
            size="sm"
            class="modal-warning"
            ok-only 
            v-model="plan_modal"
          >
          <b-row>
            <b-col sm="2">
                <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
              </b-col>
              <b-col sm="10">
                <b-row>
                <b>You have hit the plan limit.</b>
                </b-row>
                <b-row>
                  You have reached the limit of adding Shops. Please upgrade your plan to add more Shops.
                </b-row>
              </b-col>
            </b-row>
          </b-modal>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

  <b-modal title="Select Address" no-close-on-esc no-close-on-backdrop size="lg" hide-footer class="modal-warning" v-model="warningModal" @ok="warningModal = false" ok-variant="warning">
    <div>
      <label>Search Address<GmapAutocomplete @place_changed="setPlace"></GmapAutocomplete>
        <span v-if="buttosstat==0">
          <button  @click="usePlace">Add</button>
        </span>
        <span v-else>
          <label>Now you can drag Marker to your loacation</label>
        </span>
      </label>
      <label>
        <div v-if=" buttosstat==1">
          <button class="btn btn-primary btn-sm" @click="revertbck">save</button> 
        </div>
      </label>
      <br/>
      <gmap-map style="width: 100%; height: 300px;" :zoom="16" :center="center">
        <gmap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position" :clickable="true" :draggable="true" @click="center=marker.position" @dragend="getMarkerPosition($event.latLng)"/><gmap-marker v-if="this.place" label="★" :position="{lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng()}"></gmap-marker>
      </gmap-map>
    </div>
  </b-modal>
<Spinner v-if="loading === true"></Spinner>
</div>
</template>

<script>
import Spinner from '../../spinner.vue'
import {mapState} from 'vuex'
export default {
  name:'shop',
  components: {Spinner},
  computed: {
    shop_view: function(){
      var _this = this
      if(this.$store.getters.get_shop_view === true){
        this.shopuser();
        this.contr1();
        this.getTotals('comp');
        // Promise.all([this.contr1(),this.getTotals()]).then(ret_val => {
          // _this.loading = false
        // });
        // this.contr1();
        // this.getTotals();
        return true
      }
      else{
        return false
      }
    },
    shop_rights: function(){
      return this.$store.getters.get_shop_rights
    },
  },

  data() {
    return {
      center:{lat: 19.283442, lng: 72.870092},
      tfrst_time:false,
      // largeModal1:false,
      show_save_btn:false,
      largeModal:false,
      plan_modal:false,
      loading:false,
      cityopt:[],
      stateopt:[],
      conopt:[],
      useropt:[],
      citysrchopt:[],
      adminuser:null,
      oldadmin:null,
      con:null,
      state:null,
      city:null,
      updateedit:0,
      shoptype:[],
      editid:null,
      shopid:null, 
      shpusername:null,
      buttosstat:0,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1, 
        perPage: 10
      },
      shop:{
        name:'',
        phone:'',
        address1:'',
        address2:'',
        pincode:'',
        gst:'',
        sale_price_editable:false,
      },
      search:{
        name:'',
        city:null,
        address2:'',
        pincode:'',
      },
      columns: [
      {
        label: 'Shop Name', 
        field: 'est_shop_name',
        width: '40%'
      },
      {
        label: 'Shop Type',
        field: 'est_type',
        width: '20%'
      },
      {
        label: 'Shop Phone',
        field: 'est_shop_phone',
        width: '10%'
      },
      {
        label: 'Pincode',
        field: 'pincode',
        width: '10%'
      },
      {
        label: 'City',
        field: 'cities.city_name',
        width: '10%'
      },
      {
        label: 'Action',
        field: 'action',
        width: '10%'
      },
      ],
      rows: [],
      hasErrors:{
        message:false,  
        shopnm:false,
        shopad1:false, 
        shopad2:false,
        shoppin:false,
        shop_gst:false,
        shopph:false,
        shopcntry:false,
        shopstate:false,
        shopcity:false,
        cmptype:false,
        shopadmin:false,
        shopnmexist:false,
      },
      errorMessage:{
        message:''
      },
      warningModal: false,
      markers: [{ position: null }],
      place: null,
    }
  },
   
    created(){
      this.allusers();
      this.contr1ed('101');
      this.state1ed('22');
      this.city1ed('2707');
    },

    mounted: function() {
      if(navigator.geolocation) {
        var self = this;
        navigator.geolocation.getCurrentPosition(function(position){
          self.center={
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          self.markers.push({
            position: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            }
          })
        })
      }
    },
    
    methods: {

      // capitalize(str) {
      //     return str.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
      // },

      chkShopExist(){
        // console.log(this.shop.name)
        var _this = this
        // this.shop.name = this.capitalize(this.shop.name)
        // console.log(this.shop.name)
        if(this.shop.name != ''){
          this.$http.get('/api/shopestablishments/chk_shop_exist?filter[where][est_shop_name]='+this.shop.name).then(function (response) {
            if(response.data.length > 0){
              _this.shop.name = ''
              _this.hasErrors.shopnmexist = true
              _this.$refs['txtshopname'].focus()
            }
          })
          .catch(function(error){
            _this.hasErrors.shopnmexist = false
          });
        }
        else{
           _this.hasErrors.shopnmexist = false
        }
      },
      
      nameAndnumber (item) {
        return `${item.username} - ${item.phone}`
      },

      allusers(){
        var _this = this
        this.$http.get('/api/users/allusers').then(function(response){
          _this.useropt = response.data;
        }).catch(function(error){

        })
      },

      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
      
      onPageChange(params) { 
        this.updateParams({page: params.currentPage});
        this.loadItems();
      },

      onPerPageChange(params) {
        this.updateParams({perPage: params.currentPerPage,page:1});
        this.loadItems();
      },

      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params.sortType,
            field: this.columns[params.columnIndex].field,
          },page:1
        });
        this.loadItems();
      },
      
      onColumnFilter(params) {
        this.updateParams(params);
        this.loadItems();
      },

      loadItems() {
        this.loading = true;
        var self = this;
        var new1=[];
        var data=[];
        var filteParam = {};
        filteParam.page = this.serverParams.page;
        filteParam.perPage = this.serverParams.perPage;
        filteParam.sort = this.serverParams.sort;
        var shopname=this.search.name;
        shopname = shopname.split(' ').join('_')
        if(this.search.name!=''){
          data=data+"&filter[where][est_shop_name][ilike]=%"+shopname+"%"
        }
        if(this.search.city!=null){
          if(this.search.city.id!=undefined){
            var cmptyp = this.search.city.id
            data= data+"&filter[where][city][ilike]=%"+cmptyp+"%"
          }
        }
        if(this.search.pincode!='' ){
          data= data+"&filter[where][pincode][ilike]=%"+this.search.pincode+"%"
        }
        this.$http.get('/api/shopestablishments?params='+ JSON.stringify(filteParam)+data).then(function (response) {
          self.totalRecords = response.data[0].totalRecords;
          response.data.shift()
          if(response.data != undefined)
          self.rows=response.data;
          self.loading = false
        })
        .catch(function(error){
          console.log(error)
          self.loading = false
        });
      },

      shopuser(){
        var _this=this
        this.$http.get('/api/shopusers').then(function(response){

        }).catch(function(error){
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
          if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
        })
      },

      fillshopgst(){
        var _this = this
        this.$http.get('/api/companies/findOne').then(function(response){
          _this.shop.gst=response.data.cmp_gst
        });
      },
      openwarning(){
        this.warningModal = true;
        this.buttosstat=0;
      },

      addshopnew(){
        var _this = this
        this.loading = true;
        this.$http.get('/api/shopestablishments/chk_plan_count').then(function(response){
          _this.loading = false;
          if('message' in response.data){
            if(response.data.message === true){
             _this.plan_modal = true
            }
            else{
              _this.plan_modal = false
               var shopoptions = _this.$refs.shptype.children;
              if (shopoptions.length) {
                _this.shoptype = shopoptions[1].value;
              }
              
              for(var i=0;i<_this.useropt.length;i++){
                // console.log(i)
                if(_this.useropt[i].role === '1'){
                  _this.adminuser=_this.useropt[i]
                }
              }
              _this.hasErrors.cmptype='';
              _this.hasErrors.shopnm= '';
              _this.hasErrors.shopad1='';
              _this.hasErrors.shopad2='';
              _this.hasErrors.shoppin='';
              _this.hasErrors.shop_gst='';
              _this.hasErrors.shopph='';
              _this.hasErrors.shopcntry='';
              _this.hasErrors.shopadmin='';
              _this.hasErrors.shopstate='';
              _this.hasErrors.shopcity='';
              _this.hasErrors.message='';
              _this.hasErrors.shopnmexist='';
              _this.errorMessage.message= '';
              _this.shop.name='';
              _this.shop.address1='';
              _this.shop.address2='';
              _this.shop.pincode='';
              _this.shop.gst='';
              _this.shop.phone='';
              _this.updateedit=0;
              _this.editid=null;
              _this.shopid=null;
              _this.shpusername=null;
              _this.show_save_btn=true;
              _this.largeModal=true;
              _this.contr1ed('101');
              _this.state1ed('22');
              _this.city1ed('2707');
              // _this.adminuser=null;
              _this.fillshopgst();
            }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
      },

      getMarkerPosition (marker) {
        this.center={lat:marker.lat(), lng:marker.lng()}
      },

      contr1(){
        var _this=this
        this.$http.get('/api/countries').then(function(response){
          _this.conopt = response.data;
          // return Promise.resolve(true)
        }).catch(function(error){
          // return Promise.resolve(true)
          console.log(error)
        })
      },

      state1(conopt){
        this.stateopt = [];
        this.cityopt=[];
        this.state =null
        this.city = null
        var _this=this
        var id=conopt.id
        this.$http.get('/api/states?filter[where][country_id]='+id).then(function(response){
          _this.stateopt=  response.data;
        }).catch(function(error){
          console.log(error)
        })
      },

      city1(stateopt){
        this.cityopt=[];
        this.city=null
        var _this=this
        var id=stateopt.id
        this.$http.get('/api/cities?filter[where][state_id]='+id).then(function(response){
          _this.cityopt=  response.data;
        }).catch(function(error){
          console.log(error)
        })
      },

      searchcity(name){
        var _this=this
        if(name.length > 2){
          this.$http.get('/api/cities?filter[where][city_name][ilike]=%'+name+'%').then(function (response) {
            _this.citysrchopt=response.data
          }).catch(function (error) {
            console.log(error)
          });
        }
      },

      shopadmined(option){
        var _this = this
        var shop={
          est_shop_id:option
        }
        this.$http.post('/api/shopusers/getShopAdmin',shop).then(function(response){
          _this.adminuser = response.data
          _this.oldadmin = response.data
        }).catch(function(error){
          console.log(error)
        })
      },

      contr1ed(option){
        var _this=this
        this.$http.get('/api/countries/'+option).then(function(response){
          _this.con = response.data
        }).catch(function(error){
          console.log(error)
        })
        this.$http.get('/api/states?&filter[where][country_id]='+option).then(function(response){
          _this.stateopt = response.data;
        }).catch(function(error){
          console.log(error)
        })
      },

      state1ed(conopt){
        var _this=this
        this.$http.get('/api/states/'+conopt).then(function(response){
          _this.state = response.data;
        }).catch(function(error){
          console.log(error)
        })
        this.$http.get('/api/cities?filter[where][state_id]='+conopt).then(function(response){
          _this.cityopt = response.data
        }).catch(function(error){
          console.log(error)
        })
      },

      city1ed(stateopt){
        var _this=this
        this.$http.get('/api/cities/'+stateopt).then(function(response){
          _this.city = response.data
        }).catch(function(error){
          console.log(error)
        })
      },

      editpro(row){
        var stateedit={}
        var cityedit={}
        this.hasErrors.cmptype='';
        this.hasErrors.shopnm= '';
        this.hasErrors.shopad1='';
        this.hasErrors.shopad2='';
        this.hasErrors.shoppin='';
        this.hasErrors.shop_gst='';
        this.hasErrors.shopph='';
        this.hasErrors.shopcntry='';
        this.hasErrors.shopadmin='';        
        this.hasErrors.shopstate='';
        this.hasErrors.shopcity='';
        this.hasErrors.message='';
        this.hasErrors.shopnmexist=false;  
        this.shop.name=row.est_shop_name;
        this.hasErrors.message=false;
        this.errorMessage.message= '';
        this.shop.address1=row.address1;
        this.shop.address2=row.address2;
        this.shop.pincode=row.pincode;
        this.shop.gst=row.shop_gst;
        this.shop.phone=row.est_shop_phone;
        this.shop.sale_price_editable=row.saleprice
        this.updateedit=1;
        this.editid=row.id;
        this.shopid=row.est_shop_id;
        this.shpusername=row.user_name;
        this.shoptype=row.est_type;

        this.shopadmined(row.est_shop_id)
        if(row.country_code!=null){
          this.contr1ed(row.country_code)
        }
        if(row.state_code!=null){
          this.state1ed(row.state_code)
        }
        if(row.city!=null){
          this.city1ed(row.city)
        }
        this.show_save_btn=true
        this.largeModal=true
      },

      viewshop(row){
        this.shop.name=row.est_shop_name;
        this.shop.address1=row.address1;
        this.shop.address2=row.address2;
        this.shop.pincode=row.pincode;
        this.shop.gst=row.shop_gst;
        this.shop.phone=row.est_shop_phone;
        this.shoptype=row.est_type;
        if(row.country_code!=null){
          this.contr1ed(row.country_code)
        }
        if(row.state_code!=null){
          this.state1ed(row.state_code)
        }
        if(row.city!=null){
          this.city1ed(row.city)
        }
        this.show_save_btn=false
        this.largeModal=true
      },

      Successsub(){
        this.loading=true
        var _this=this
        _this.hasErrors.cmptype=false;
        _this.hasErrors.shopnm=false;
        _this.hasErrors.shopad1=false;
        _this.hasErrors.shopad2=false;
        _this.hasErrors.shoppin=false;
        _this.hasErrors.shop_gst=false;
        _this.hasErrors.shopph=false;
        _this.hasErrors.shopadmin=false;
        _this.hasErrors.shopcntry=false;
        _this.hasErrors.shopstate=false;
        _this.hasErrors.shopcity=false;
        _this.hasErrors.shopnmexist=false;
        var submit_true=0;
        var regex=/^[a-zA-Z0-9\s,.'-/]{3,}$/
        var prex=/^[0-9]{10,15}$/
        var pirex=/^[0-9]{6}$/
        var eregex= /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/
        if(this.shoptype.length==0){
          _this.hasErrors.cmptype=true;
          submit_true=1;
        }
        if(regex.test(this.shop.name)==false){
          _this.hasErrors.shopnm=true;
          submit_true=1
        }

        if(regex.test(this.shop.address1)==false){
          _this.hasErrors.shopad1=true;
          submit_true=1
        }
        if(this.adminuser==null){
          _this.hasErrors.shopadmin=true
          submit_true=1;
        }
        if(this.con==null){
          _this.hasErrors.shopcntry=true
          submit_true=1;
        }
        if(this.state==null){
          _this.hasErrors.shopstate=true
          submit_true=1;
        }
        if(this.city==null){
          _this.hasErrors.shopcity=true
          submit_true=1;
        }
        if( pirex.test(this.shop.pincode)==false){
          _this.hasErrors.shoppin=true;
          submit_true=1
        }
        if(regex.test(this.shop.gst)==false && this.shop.gst!=''){
          _this.hasErrors.shop_gst=true;
          submit_true=1
        }
        if (prex.test(this.shop.phone)==false){
          _this.hasErrors.shopph=true;
          submit_true=1
        }

        if(submit_true==0){
          var useradmin=null
          var shp_username=null
          var shp_userphone=null
          if(this.adminuser !== null){
            useradmin=this.adminuser.email
            shp_username=this.adminuser.username
            shp_userphone=this.adminuser.phone
          }

          var shop={
            est_type:this.shoptype,
            est_shop_name:this.shop.name,
            est_shop_phone:this.shop.phone,
            address1:this.shop.address1,
            address2:this.shop.address2,
            pincode:this.shop.pincode,
            country_code:this.con.id,
            state_code:this.state.id,
            city:this.city.id,
            shop_gst:this.shop.gst,
            saleprice:this.shop.sale_price_editable,
            est_latitude:this.center.lat,
            est_longititude:this.center.lng,
            shopid:this.shopid,
            user_admin:useradmin,
            shpusername:shp_username,
            shpuserphone:shp_userphone,
            oldadmin:this.oldadmin,
          }
          
          if(this.updateedit==0){
            this.$http.post('/api/shopestablishments', shop).then(function(response){
              _this.loading=false
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              _this.hasErrors.message=true;
              _this.errorMessage.message= 'Shop Added Successfully';
               _this.getTotals();
              setTimeout(function(){ _this.errorMessage.message='';}, 2000);
              _this.reset();
              _this.largeModal=false;
            }).catch(function(error){
              _this.loading=false
              _this.hasErrors.message=true;
              _this.errorMessage.message= 'Something went wrong!, try later';
              console.log(error)
              setTimeout(function(){ _this.errorMessage.message='';}, 2000);
            })
          }
          if(this.updateedit==1){
            this.$http.post('/api/shopestablishments/update?where[id]='+this.editid,shop).then(function(response){
              _this.loading=false
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              _this.hasErrors.message=true;
              _this.errorMessage.message= 'Shop Updated Successfully';
              setTimeout(function(){ _this.errorMessage.message='';}, 2000);
              _this.reset();
              _this.getTotals();
              _this.largeModal=false;
            }).catch(function(error){
              _this.loading=false
              _this.hasErrors.message=true;
              _this.errorMessage.message= "Something went wrong, try later";
              setTimeout(function(){ _this.errorMessage.message='';}, 2000);
            })
          }
        }
        else{
          _this.loading=false
        }
      },

      serachprev(){
        this.serverParams.page = 1
        this.$refs['my-table'].reset()
        this.loadItems()
      },

      setDescription(description) {
        this.description = description;
      },

      setPlace(place) {
        this.position=[];
        this.buttosstat=0;
        this.place = place;
        this.center={lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng()};
      },
      
      usePlace(place) {
        this.buttosstat=1
        this.markers=[]
        if (this.place) {
          this.markers.push({
            position: {
              lat: this.place.geometry.location.lat(),
              lng: this.place.geometry.location.lng(),
            }
          })
          this.place=null;
        }else{
          this.markers=[{position:{lat:this.center.lat, lng:this.center.lng}}]
        }
      },

      revertbck(){
        this.largeModal=true;
        this.warningModal=false;
      },

      reset(){
        var _this=this;
        _this.shop.name ='';
        _this.con=null,
        _this.state = null;
        _this.city = null;
        _this.shoptype=null;
        _this.shop.address1 = '' ;
        _this.shop.address2 = ''; 
        _this.shop.pincode = ''; 
        _this.shop.gst = '' ;
        _this.shop.phone = ''; 
      },
 
      getTotals(val){
        if(val === 'comp'){
          if(this.tfrst_time === false){
            this.tfrst_time = true
          }
          else{
            return
          }
        }
        this.loadItems()
        // return Promise.resolve(true)
      },

      deleteshoplist(shoplistid){
        var _this=this
        var id =shoplistid.id;
        this.$http.delete('/api/shopestablishments/'+id).then(function (response) {
          _this.getTotals();
        }).catch(function (error) {
          console.log(error)
        });
      },
    }
  }
</script>

<style type="text/css">
  .modal-header{
    background-color: #1a94cb;
    columns: #fff;
  }
  .modal-title{
  color:black;
  font-weight:bold;
  }
</style>


// WEBPACK FOOTER //
// src/views/setting/Shop.vue